import Index from './Index.vue';

export default {
  path: 'cores',
  name: 'produto-cor',
  component: Index,
};
